import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

interface SignupNudgeProps {
  icon: ReactNode;
  message: string;
}

export const SignupNudge = ({ icon, message }: SignupNudgeProps) => {
  return (
    <div className="flex items-center justify-between gap-3 p-3 rounded-xl bg-primary/5 border border-primary/10">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <span className="text-primary flex-shrink-0">{icon}</span>
        <span>{message}</span>
      </div>
      <Link
        to="/auth"
        className="flex items-center gap-1 text-xs font-semibold text-primary hover:text-primary/80 whitespace-nowrap min-h-[44px] px-2"
      >
        Sign up free <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
  );
};
